export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-21.e06e8992.png";